export const formatDate = (dateString) => {
  const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
  return new Date(dateString).toLocaleDateString('pt-BR', options);
};

export const formatDateTime = (dateString) => {
  const options = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  };
  return new Date(dateString).toLocaleString('pt-BR', options);
};

export const formatValue = (value, currency) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: currency
  }).format(value);
};

export const AssetClass = Object.freeze({
  FixedIncome: 'FIXED_INCOME',
  VariableIncome: 'VARIABLE_INCOME',
  Crypto: 'CRYPTO',
  Cash: 'CASH',
  Other: 'OTHER'
});

export const AssetInstrumentType = Object.freeze({
  CDB: 'CDB',
  LCI: 'LCI',
  LCA: 'LCA',
  CRI: 'CRI',
  CRA: 'CRA',
  LC: 'LC',
  Debenture: 'DEBENTURE',
  TreasurySelic: 'TREASURY_SELIC',
  TreasuryIpca: 'TREASURY_IPCA',
  TreasuryPrefixed: 'TREASURY_PREFIXED',
  Stock: 'STOCK',
  StockBRL: 'STOCK_BRL',
  StockUSA: 'STOCK_USA',
  ETF: 'ETF',
  FII: 'FII',
  BDR: 'BDR',
  Crypto: 'CRYPTO',
  Fiat: 'FIAT',
  FixedIncomeETF: 'FIXED_INCOME_ETF',
});

export const getDecimalQuantityFromAssetClass = (assetClass) => {
  const decimalScaleMap = new Map([
    [AssetClass.Crypto, 8],
    [AssetClass.VariableIncome, 0],
  ]);

  const defaultDecimalScale = 2;
  const result = decimalScaleMap.has(assetClass) ? decimalScaleMap.get(assetClass) : defaultDecimalScale;
  return result;
};

export const getDecimalPriceFromAssetClass = (assetClass) => {
  const decimalScaleMap = new Map([
    [AssetClass.Crypto, 8],
  ]);

  const defaultDecimalScale = 2;
  return decimalScaleMap.has(assetClass) ? decimalScaleMap.get(assetClass) : defaultDecimalScale;
};

export const getAssetClasses = () => [
  { label: 'Renda Fixa', value: AssetClass.FixedIncome },
  { label: 'Renda Variável', value: AssetClass.VariableIncome },
  { label: 'Cripto', value: AssetClass.Crypto },
  { label: 'Caixa', value: AssetClass.Cash },
  { label: 'Outro', value: AssetClass.Other },
];

export const getAssetInstrumentTypesByClass = (assetClass) => {
  switch (assetClass) {
    case AssetClass.FixedIncome:
      return [
        { label: 'CDB', value: AssetInstrumentType.CDB },
        { label: 'LCI', value: AssetInstrumentType.LCI },
        { label: 'LCA', value: AssetInstrumentType.LCA },
        { label: 'CRI', value: AssetInstrumentType.CRI },
        { label: 'CRA', value: AssetInstrumentType.CRA },
        { label: 'LC', value: AssetInstrumentType.LC },
        { label: 'Debênture', value: AssetInstrumentType.Debenture },
        { label: 'Tesouro Selic', value: AssetInstrumentType.TreasurySelic },
        { label: 'Tesouro IPCA', value: AssetInstrumentType.TreasuryIpca },
        { label: 'Tesouro Prefixado', value: AssetInstrumentType.TreasuryPrefixed },
        { label: 'ETF de Renda Fixa', value: AssetInstrumentType.FixedIncomeETF },
      ];
    case AssetClass.VariableIncome:
      return [
        { label: 'Ação BR', value: AssetInstrumentType.StockBRL },
        { label: 'Ação USA', value: AssetInstrumentType.StockUSA },
        { label: 'ETF', value: AssetInstrumentType.ETF },
        { label: 'FII', value: AssetInstrumentType.FII },
        { label: 'BDR', value: AssetInstrumentType.BDR },
      ];
    case AssetClass.Crypto:
      return [{ label: 'Cripto', value: AssetInstrumentType.Crypto }];
    case AssetClass.Cash:
      return [{ label: 'Fiat', value: AssetInstrumentType.Fiat }];
    default:
      return [];
  }
};

export const getInstrumentTypeLabel = (instrumentType) => {
  const labels = {
    [AssetInstrumentType.CDB]: 'CDB',
    [AssetInstrumentType.LCI]: 'LCI',
    [AssetInstrumentType.LCA]: 'LCA',
    [AssetInstrumentType.CRI]: 'CRI',
    [AssetInstrumentType.CRA]: 'CRA',
    [AssetInstrumentType.LC]: 'LC',
    [AssetInstrumentType.Debenture]: 'Debênture',
    [AssetInstrumentType.TreasurySelic]: 'Tesouro Selic',
    [AssetInstrumentType.TreasuryIpca]: 'Tesouro IPCA',
    [AssetInstrumentType.TreasuryPrefixed]: 'Tesouro Prefixado',
    [AssetInstrumentType.Stock]: 'Ação',
    [AssetInstrumentType.StockBRL]: 'Ação BR',
    [AssetInstrumentType.StockUSA]: 'Ação USA',
    [AssetInstrumentType.ETF]: 'ETF',
    [AssetInstrumentType.FII]: 'FII',
    [AssetInstrumentType.BDR]: 'BDR',
    [AssetInstrumentType.Crypto]: 'Cripto',
    [AssetInstrumentType.Fiat]: 'Fiat',
    [AssetInstrumentType.FixedIncomeETF]: 'ETF de Renda Fixa',
  };
  return labels[instrumentType] || instrumentType;
};

export const toInputDate = (dateStr) => {
  if (!dateStr) return '';
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return dateStr;
  const [day, month, year] = dateStr.split('/');
  if (day && month && year) return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  return dateStr;
};

export const toDisplayDate = (dateStr) => {
  if (!dateStr) return '';
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateStr)) return dateStr;
  const [year, month, day] = dateStr.split('-');
  if (year && month && day) return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`;
  return dateStr;
};
